export class ModuleBase {
    protected module: string;

    constructor(module: string) {
        this.module = module;
    }
}